import '../../styles-new/pages/context/columnists.scss';
import { ColumnistDropdown } from '../context/columnist-dropdown';
import { BecomeColumnistPopup } from '../context/become-columnist-popup';

document.addEventListener('DOMContentLoaded', () => {
  const searchInput = document.querySelector('.context-search input');
  const contextSelect = document.querySelector('.context-select-dropdown');
  const selectItems = document.querySelectorAll('.context-select-dropdown__item');
  const allAuthorsList = document.querySelector('.all-authors-list');
  const resetFilterBtn = document.querySelector('.reset-filter-btn');
  const searchButton = document.querySelector('.context-search__btn');
  const letterButtons = document.querySelectorAll('.letters-filter__letter');

  // Set display flex for all column-author elements
  document.querySelectorAll('.column-author').forEach(author => {
    author.style.display = 'flex';
  });

  // Initialize all columnist dropdowns
  document.querySelectorAll('.context-select_columnist').forEach(select => {
    new ColumnistDropdown(select);
  });
  new BecomeColumnistPopup();

  // Hide context-select initially
  contextSelect.style.display = 'none';

  // Show context-select when user starts typing
  searchInput.addEventListener('input', (e) => {
    const searchValue = e.target.value.toLowerCase();
    let hasVisibleItems = false;

    if (searchValue.length > 0) {
      // Filter select items
      selectItems.forEach(item => {
        const itemText = item.textContent.toLowerCase();
        if (itemText.includes(searchValue)) {
          item.style.display = 'block';
          hasVisibleItems = true;
        } else {
          item.style.display = 'none';
        }
      });

      // Show/hide context-select based on visible items
      contextSelect.style.display = hasVisibleItems ? 'block' : 'none';
    } else {
      contextSelect.style.display = 'none';
    }
  });

  document.addEventListener('click', (e) => {
  if (
    !searchInput.contains(e.target) &&
    !contextSelect.contains(e.target)
  ) {
    contextSelect.style.display = 'none';
  }
});

  searchInput.addEventListener('focus', (e) => {
    const searchValue = e.target.value?.toLowerCase();;
    if(searchValue?.length) {
      const items = Array.from(selectItems);
      const hasVisibleItems = items?.some(item => {
        const itemText = item.textContent.toLowerCase();

        return itemText.includes(searchValue)
      });

      if(hasVisibleItems) {
        contextSelect.style.display = 'block';
      }
    }
  })

  // Handle search button click
  searchButton.addEventListener('click', () => {
    const searchValue = searchInput.value.toLowerCase();
    contextSelect.style.display = 'none'; // Hide dropdown when searching
    filterAuthorsList(searchValue);
  });

  // Handle select item click
  selectItems.forEach(item => {
    item.addEventListener('click', () => {
      searchInput.value = item.textContent;
      contextSelect.style.display = 'none'; // Hide dropdown when item is selected
    });
  });

  // Handle letter filter click
  letterButtons.forEach(button => {
    button.addEventListener('click', () => {
      // Remove active class from all buttons
      letterButtons.forEach(btn => btn.classList.remove('letters-filter__letter_active'));
      // Add active class to clicked button
      button.classList.add('letters-filter__letter_active');

      const letter = button.textContent.toLowerCase();
      filterAuthorsByLetter(letter);
    });
  });

  // Handle reset filter button
  resetFilterBtn.addEventListener('click', () => {
    searchInput.value = '';
    contextSelect.style.display = 'none';
    selectItems.forEach(item => item.style.display = 'block');
    // Remove active class from all letter buttons
    letterButtons.forEach(btn => btn.classList.remove('letters-filter__letter_active'));
    filterAuthorsList('');
  });

  // Function to filter authors list
  function filterAuthorsList(searchValue) {
    const authorBlocks = allAuthorsList.querySelectorAll('.all-authors-list__letter-block');

    authorBlocks.forEach(block => {
      const authors = block.querySelectorAll('.all-authors-list__authors .column-author');
      let hasVisibleAuthors = false;

      authors.forEach(author => {
        const authorName = author.querySelector('.column-author__name').textContent.toLowerCase();
        if (authorName.includes(searchValue)) {
          author.style.display = 'flex';
          hasVisibleAuthors = true;
        } else {
          author.style.display = 'none';
        }
      });

      // Show/hide letter block based on visible authors
      block.style.display = hasVisibleAuthors ? 'block' : 'none';
    });
  }

  // Function to filter authors by letter
  function filterAuthorsByLetter(letter) {
    const authorBlocks = allAuthorsList.querySelectorAll('.all-authors-list__letter-block');

    authorBlocks.forEach(block => {
      const blockLetter = block.querySelector('.all-authors-list__letter').textContent.toLowerCase();
      const authors = block.querySelectorAll('.all-authors-list__authors .column-author');

      if (blockLetter === letter) {
        block.style.display = 'block';
        authors.forEach(author => {
          author.style.display = 'flex';
        });
      } else {
        block.style.display = 'none';
      }
    });
  }
});
